export class AppLang {
  public static readonly DEFAULT = 'pt';
  public static readonly ENG = 'en';
}
